import React, { PureComponent } from 'react'
import { createContainer } from '@dbk-legacy/muster/react'
import { TouchableOpacity, StyleSheet, ScrollView } from 'react-native'
import { GenericEdited, Visible, DownloadIcon, Hide, ChevronDown, ArrowRight, Info } from '@dbk/ui-icons'
import { View } from '@dbk/ui-react-utils'
import format from 'date-fns/format'
import {
  NavigationListItemHeader,
  NavigationListItemFooter,
  NavigationListItemContent,
} from '@dbk/ui-list'
import { DotIcon } from '../../../../../../src/components/common/icons'
import { Checkbox } from '@dbk/ui-forms'
import Text, { Large } from '@dbk/ui-text'
import { PALETTE } from '../../../../../../src/constants'
import PropTypes from 'prop-types'
import { formatDate } from '../report-utils'
import additionalStyles from './report-category.styles'
import { EDELIVERY_CATEGORY_ID, PDF_MIME_TYPE } from '../constants'
import envConfig  from '../../../../../../db-env-build'   
import { RM_REGION, KEY_CODE } from '../../../constants'
import { Accordion, AccordionItem } from '@dbk/ui-accordion';
import labelForPFid from '../../../../../../src/utils/portfolio-number-aria-label'

const ReportCategoryListItem = props => {
  const { item , i18n: { messages }} = props
  const {
    auth: { langCode, documentPreviewDisabled, documentDownloadDisabled },
    reports: { selectedCategoryId },
  } = props
  let displayId = ''
  let refCurrency = ''
  if ((item.portfolioId && item.bpId) || (item.portfolioId && !item.bpId)) {
    displayId = item.portfolioId
    refCurrency = item.refCurrency
  } else if (item.bpId && !item.portfolioId) {
    displayId = item.bpId
    refCurrency = ''
  }

  const downloadDoc = (e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      if(documentDownloadDisabled){
        return;
      }
    props.downloadIndividualReport(item, e);
    }
  }

  const onItemClicked = (item, event) => {
    props.handlePreviewClick(item, event)
  }


  const receivedDate = formatDate(item.receivedDate, langCode)
  const cursorClass = documentPreviewDisabled ? 'notAllowedCursor' : 'pointerCursor'; //WMCE-42437- Switching cursor style to not allowed when preview is disabled for RM
  const categoryId = parseInt(item.categoryIds, 10);
  return (
    <View style={StyleSheet.flatten(additionalStyles.reportsTable)}>
      <View style={StyleSheet.flatten(additionalStyles.tableRootContent)}>
      <View style={StyleSheet.flatten(additionalStyles.container)} className="report-category-container">
          <View style={StyleSheet.flatten(additionalStyles.checkbox)} className="report-category-checkbox">
            <Checkbox
              title={item.documentName}
              // name="checkbox"
              checked={item.checked}
              indeterminate={item.isIndeterminate}
              className="checkboxClass"
              onChange={() => props.handleReportItemClick(item)}
              testID="checkbox_report_reportCategorylistItem_test"
            />
          </View>
          <View style={StyleSheet.flatten(additionalStyles.reportName)} className="report-category-reportName">
            { documentPreviewDisabled || (item.mimeType && item.mimeType.toLowerCase() != PDF_MIME_TYPE.toLowerCase()) ?
            <View style={StyleSheet.flatten(additionalStyles.otherRow)} tabIndex={0} aria-label={item.documentName +" "+ (!item.read ? messages['app.reports.reportUnread'] : "")}>
              <Text size={"large"} className="textStyle" >{item.documentName} </Text>
              {!item.read && <div style={StyleSheet.flatten(additionalStyles.iconStyle)}><DotIcon /></div>}  
            </View>
            :
            <TouchableOpacity focusable={true} style={StyleSheet.flatten(additionalStyles.flexRow)} onPress={(e) => onItemClicked(item, e)} onClick={() => onItemClicked(item)} accessibilityLabel={item.documentName +" "+ (!item.read ? messages['app.reports.reportUnread'] : "")}>
                <Text size={"large"} className="textStyle">{item.documentName} </Text>
                {!item.read && <div style={StyleSheet.flatten(additionalStyles.iconStyle)}><DotIcon /></div>}
            </TouchableOpacity> }
          </View>
          <View style={StyleSheet.flatten(additionalStyles.portfolio)} tabIndex={0} className="report-category-portfolio" aria-label={categoryId === EDELIVERY_CATEGORY_ID.OTHER_DOCUMENTS ? messages['app.common.nullValue'] : (displayId ? labelForPFid(displayId): (refCurrency ? labelForPFid(refCurrency) : messages['app.common.nullValue'] ))}>
            <Text size={"large"}>
            {/* { categoryId === EDELIVERY_CATEGORY_ID.OTHER_DOCUMENTS ? '-' : (displayId ? (displayId+(refCurrency ? ' - ' + refCurrency : '')): (refCurrency ? refCurrency : '-' ))} */}
            { categoryId === EDELIVERY_CATEGORY_ID.OTHER_DOCUMENTS ? '-' : (displayId ? (displayId): (refCurrency ? refCurrency : '-' ))}
            </Text>
          </View>
          <View style={StyleSheet.flatten(additionalStyles.date)} tabIndex={0} className="report-category-date">
            <Text size={"large"} testID="text_date_customTransactionHistory_test">{receivedDate}</Text>
          </View>
          <View style={StyleSheet.flatten(additionalStyles.preview)} className="report-category-preview">
          { documentPreviewDisabled || (item.mimeType && item.mimeType.toLowerCase() != PDF_MIME_TYPE.toLowerCase()) ?
              <Hide className='disable-click' width={28} height={17} color={PALETTE.primaryText}/> :
              <div className='preview-icon' tabIndex="0" role="button" aria-label={messages['app.chedelivery.reports.preview']} onKeyDown={(event) => onItemClicked(item, event)}>
                <Visible className='clickable' onClick={() => props.handlePreviewClick(item)} color={PALETTE.secondaryActive} />
              </div> 
          }

          </View>
          <View style={StyleSheet.flatten(additionalStyles.download)} aria-label={messages['app.chedelivery.reports.download']} role="button" onKeyDown={(event) => downloadDoc(event)} onClick={() => downloadDoc()} className="report-category-download">
            <DownloadIcon className={ documentDownloadDisabled ? '' : 'clickable'}
              color={ documentDownloadDisabled ? PALETTE.primaryText : PALETTE.secondaryActive}
              width={28}
              height={28}

            />
          </View>
        </View>
        { ( categoryId === EDELIVERY_CATEGORY_ID.FROM_YOUR_ADVISOR) && item.msgToClient && 
          <View className="accordion-container">
            <Accordion
              className="accordion-header"
              renderIconForClose={() => <ChevronDown className="downArrow" width={24} height={24} color={PALETTE.secondaryActive} />}
              renderIconForOpen={() => <View className="arrow-right"><ArrowRight width={24} height={24} color={PALETTE.secondaryActive} /></View>}
            >
              <AccordionItem
                className="accordion-content"
                renderTitle={
                  <View className="title-container">
                    <View className="icon-container"><Info className="acc-icon" color={PALETTE.secondaryActive} height={24} width={24}/></View>
                    <Text>{props.i18n.messages['app.chedelivery.reports.messageFromRM']}</Text>
                  </View>
                }
                itemKey={1}
                key={1}
              >
                <View>
                  <ScrollView className="max-scroll-height">
                    <Text>{item.msgToClient}</Text>
                  </ScrollView>
                </View>
              </AccordionItem>
            </Accordion>
          </View>}
      </View>
      {/* ))} */}
    </View>
  )
}

ReportCategoryListItem.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  item: PropTypes.string,
  downloadIndividualReport: PropTypes.func
}

ReportCategoryListItem.defaultProps = {
  i18n: {},
  item: {},
}

export default createContainer(
  {
    $queries: {
      changePage: { $call: 'ui.history.replace' },
      i18n: {
        messages: true,
      },
      auth: {
        langCode: true,
        documentPreviewDisabled: true,
        documentDownloadDisabled: true
      },
      reports: {
        selectedCategoryId: true,
      },
    },
  },
  ({ ui, ...queries }) => ({
    ...queries,
  })
)(ReportCategoryListItem)
